import { themr } from '@friendsofreactjs/react-css-themr';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import intlEquipped from '../../../hocs/intlEquipped';

import CancelSubscriptionFeedbackModal from './CancelSubscriptionFeedbackModal';
import { actions as modalsActions } from '../../../redux/modals';

const mapDispatchToProps = dispatch => ({
    showNext: (modalType, props) => dispatch(modalsActions.showModal(modalType, props)),
});

export default compose(
    connect(null, mapDispatchToProps),
    themr('CancelSubscriptionFeedbackModal'),
    intlEquipped
)(CancelSubscriptionFeedbackModal);
